/**
 * Visão Calendário do setor: o calendário compartilhado (Dia / Semana / Mês
 * / Ano) com ambientes, lotes, tarefas ou peças desmembradas pelo prazo que
 * vale ou pela previsão do gestor (desenhada tracejada). Tom = estado;
 * atrasado = danger.
 */
import React, { useMemo, useState } from "react";

import Calendar from "../../../components/Calendar";
import { plural } from "../../../utils/dinheiro";
import { BASES_CALENDARIO } from "../dados/calendario";
import { Barra, Espaco } from "./styles";
import { SeletorSegmentado } from "./ui";
import { calendarioDoSetor } from "./visoes";

const LEGENDA = [
  { rotulo: "Atrasado", tom: "danger" },
  { rotulo: "Em produção / andamento", tom: "info" },
  { rotulo: "Pausado", tom: "warning" },
  { rotulo: "Aguardando", tom: "neutral" },
];

const NOMES = {
  ambiente: ["ambiente", "ambientes"],
  lote: ["lote", "lotes"],
  tarefa: ["tarefa", "tarefas"],
  peca: ["peça", "peças"],
};

export default function CalendarioSetor({ entidade, demandas, tarefas, pecas, hoje, base, onMudarBase, onAbrir }) {
  const [cursor, setCursor] = useState(() => new Date());
  const [escala, setEscala] = useState("month");
  const { eventos, semData, vocab } = useMemo(
    () => calendarioDoSetor(entidade, { demandas, tarefas, pecas, base, hoje }),
    [entidade, demandas, tarefas, pecas, base, hoje]
  );
  const [singular, pluralNome] = NOMES[entidade] || NOMES.ambiente;
  const semDataTexto = base === "prevista" ? "sem previsão definida" : "sem prazo";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 0 }}>
      <Barra>
        <SeletorSegmentado
          rotulo="Data do calendário"
          opcoes={BASES_CALENDARIO}
          valor={base}
          onChange={onMudarBase}
        />
        <span style={{ display: "inline-flex", gap: 12, flexWrap: "wrap", fontSize: 12, color: "var(--ink-3)" }}>
          {LEGENDA.map((item) => (
            <span key={item.tom} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              <span
                aria-hidden="true"
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 3,
                  background: `var(--${item.tom}-bg)`,
                  border: `1px solid var(--${item.tom}-border)`,
                }}
              />
              {item.rotulo}
            </span>
          ))}
        </span>
        <Espaco />
        {semData > 0 && (
          <span style={{ fontSize: 12, color: "var(--ink-3)" }}>
            {plural(semData, singular, pluralNome)} {semDataTexto} (fora do calendário)
          </span>
        )}
      </Barra>
      <Calendar
        events={eventos}
        cursor={cursor}
        scale={escala}
        onCursorChange={setCursor}
        onScaleChange={setEscala}
        onSelectEvent={(evento) => onAbrir(evento.payload)}
        emptyMessage={`Nenhum ${singular} neste período.`}
        weekStartsOn={1}
        vocab={vocab}
      />
    </div>
  );
}
